import React, { useEffect, useState } from 'react'
import Layout from '../components/layout/Layout'
import Seo from '../components/Seo'
import { Link, useLocation } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const Contact: React.FC = () => {
  const location = useLocation()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [sent, setSent] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    setSent(params.get('sent') === '1')
  }, [location.search])

  const nextUrl = (typeof window !== 'undefined' ? window.location.origin : 'https://2domy.pl') + '/contact?sent=1'
  return (
    <Layout>
      <Seo title="Kontakt — 2domy.pl" canonical="https://2domy.pl/contact" robots="index,follow" />
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="mb-4">
          <Link to="/" className="inline-flex items-center text-slate-700 hover:text-slate-900">
            <ArrowLeft className="h-4 w-4 mr-2" /> Powrót do strony głównej
          </Link>
        </div>
        <div className="card-glass p-6 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2">Kontakt</h1>
          <p className="text-sm text-slate-600 mb-6">Napisz do nas lub użyj formularza poniżej.</p>
          <div className="text-sm text-slate-700 mb-6">
            <div><span className="font-medium">E‑mail:</span> <a href="mailto:kontakt@2domy.pl" className="text-blue-600 hover:underline">kontakt@2domy.pl</a></div>
          </div>

          {sent ? (
            <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-md p-4">
              Dziękujemy! Wiadomość została wysłana. Odpowiemy możliwie szybko.
            </div>
          ) : (
            <form 
              action="https://formsubmit.co/kontakt@2domy.pl" 
              method="POST" 
              className="space-y-4"
              onSubmit={() => { if (!isSubmitting) setIsSubmitting(true) }}
            >
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_subject" value="Wiadomość z formularza kontaktowego 2domy.pl" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_next" value={nextUrl} />

              <div>
                <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1">Imię</label>
                <input id="name" name="name" type="text" required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="Jan" />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">E‑mail</label>
                <input id="email" name="email" type="email" required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="jan.kowalski@example.com" />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-slate-700 mb-1">Temat</label>
                <input id="subject" name="subject" type="text" required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="Krótki temat wiadomości" />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-1">Wiadomość</label>
                <textarea id="message" name="message" rows={5} required readOnly={isSubmitting} className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/90" placeholder="Twoja wiadomość..." />
              </div>

              <div className="pt-2">
                <button type="submit" disabled={isSubmitting} className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed">
                  {isSubmitting ? 'Wysyłanie…' : 'Wyślij'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default Contact


